import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useStockStore from 'src/components/routes/stock/store'

export default async function loader() {
  await isAppStateReady()

  const tendersPromise = useStockStore.getState().getTenders()

  return defer({
    data: Promise.all([tendersPromise])
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Supplier Tenders error: ', error)
        return false
      }),
  })
}
